import { Dialog, DialogContent, DialogActions, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { editProyecto } from "../../components/functions/Projects";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";
import CustomButton from "../../ui/button/Button";

const EditProjectModal = ({
  API_URL,
  tipoReportes,
  usuariosHabilitadosPM,
  open,
  onClose,
  onConfirm,
  proyecto,
}) => {
  const [proyectoForm, setProyectoForm] = useState(null);
  const [requiereURL, setRequiereURL] = useState(false);

  useEffect(() => {
    if (proyecto && open) {
      setProyectoForm(proyecto);
      if (proyecto.urlEncuesta) {
        setRequiereURL(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proyecto, open]);

  const handleEditProject = async () => {
    if (!proyectoForm) return;

    if (!proyectoForm.nombre || proyectoForm.nombre.trim() === "") {
      return;
    }

    if (
      !proyectoForm?.tipoReporte ||
      Object.keys(proyectoForm?.tipoReporte).length === 0
    ) {
      return;
    }

    if (
      requiereURL &&
      (!proyectoForm.urlEncuesta || proyectoForm.urlEncuesta.trim() === "")
    ) {
      return;
    }

    if (
      !proyectoForm.usuarioPM ||
      Object.keys(proyectoForm.usuarioPM).length === 0
    ) {
      return;
    }

    try {
      await editProyecto(API_URL, proyectoForm);
      onConfirm(true, proyectoForm);
    } catch (error) {
      onConfirm(false, proyecto);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogContent>
        <div>
          <h2>Editar Proyecto</h2>
          <Box
            className="stepper-step-content"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}
          >
            <div
              className="d-grid align-items-center"
              style={{ gridTemplateColumns: "250px 1fr", rowGap: "16px" }}
            >
              <label className="form-label">Nombre:</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa el nombre"
                value={proyectoForm?.nombre || ""}
                onChange={(e) =>
                  setProyectoForm((prev) => ({
                    ...prev,
                    nombre: e.target.value,
                  }))
                }
              />
              <label className="form-label">Tipo de reporte:</label>
              <SelectAutoComplete
                options={tipoReportes}
                field="proyecto.tipoReporte"
                fieldC="descripcion"
                width={"100%"}
                value={proyectoForm?.tipoReporte || {}}
                onChange={(e, value) =>
                  setProyectoForm((prev) => ({
                    ...prev,
                    tipoReporte: value,
                  }))
                }
              />
              <label className="form-label" htmlFor="soporteRegionalCFE">
                ¿Requiere URL de encuesta de satisfacción?
              </label>
              <label className="switch">
                <input
                  id="soporteRegionalCFE"
                  type="checkbox"
                  checked={requiereURL}
                  onChange={(e) => setRequiereURL((prev) => !prev)}
                />
                <span className="slider round"></span>
              </label>
              <label
                style={{
                  display: requiereURL ? "block" : "none",
                }}
                className="form-label"
              >
                URL Encuesta de satisfacción:
              </label>
              <input
                style={{
                  display: requiereURL ? "block" : "none",
                }}
                className="form-input"
                type="text"
                placeholder="Ingresa URL"
                value={proyectoForm?.urlEncuesta || ""}
                onChange={(e) =>
                  setProyectoForm((prev) => ({
                    ...prev,
                    urlEncuesta: e.target.value,
                  }))
                }
              />
              <label className="form-label">PM responsable del proyecto:</label>
              <SelectAutoComplete
                options={usuariosHabilitadosPM}
                field="proyecto.usuarioPM"
                fieldC="nombre"
                width={"100%"}
                value={proyectoForm?.usuarioPM || {}}
                onChange={(e, value) =>
                  setProyectoForm((prev) => ({
                    ...prev,
                    usuarioPM: value,
                  }))
                }
                listHeight={"200px"}
              />
            </div>
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          className="notifications-button"
          text={"Guardar"}
          color={"#FFFFFF"}
          background={"#223D51"}
          fontStyle={"normal"}
          fontWeight={500}
          fontSize={"14px"}
          height={"40px"}
          type={"button"}
          onClick={handleEditProject}
        />
      </DialogActions>
    </Dialog>
  );
};

export default EditProjectModal;
